export const firstAccessUrl = (returnURl: string) => {
  return `https://my.capitual.com/servicelogin/22?public=0d804040-c5db-11ea-b70f-9dbe56f76fd3&perms=create_organization,manage_organization_roles,list_organization_roles,edit_organization_profile,manage_organization_users,list_organizations,check_2fa,check_pin&return_url=${returnURl}`;
};
